export enum NavItem {
    SOLUTION = "solution",
    DESIGN = "design",
    RESEARCH = "research",
    GUIDELINES = "guidelines",
    ABOUT = "about",
    BLOG = "blog"
}

export enum NavPath {
    HOME = "/mhci/capstone/2021/pnnl/",
    RESEARCH = "/mhci/capstone/2021/pnnl/research",
    DESIGN = "/mhci/capstone/2021/pnnl/design",
    GUIDELINES = "/mhci/capstone/2021/pnnl/guidelines",
    ABOUT = "/mhci/capstone/2021/pnnl/about"
}